import { configureStore, combineReducers, AnyAction, Dispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {
  selectionsApiSlice,
  diagnosesApiSlice,
  generationTaskApiSlice,
  notificationApiSlice,
  biomarkersApiSlice,
  diagnosesGroupsApiSlice,
  profileApiSlice,
  laboratoriesApiSlice,
  facilitiesApiSlice,
  salesRepresentativesApiSlice,
  providersApiSlice,
  selectionScope,
} from '@src/api';
const reducer = combineReducers({
  [selectionsApiSlice.reducerPath]: selectionsApiSlice.reducer,
  [diagnosesApiSlice.reducerPath]: diagnosesApiSlice.reducer,
  [diagnosesGroupsApiSlice.reducerPath]: diagnosesGroupsApiSlice.reducer,
  [generationTaskApiSlice.reducerPath]: generationTaskApiSlice.reducer,
  [notificationApiSlice.reducerPath]: notificationApiSlice.reducer,
  [biomarkersApiSlice.reducerPath]: biomarkersApiSlice.reducer,
  [laboratoriesApiSlice.reducerPath]: laboratoriesApiSlice.reducer,
  [facilitiesApiSlice.reducerPath]: facilitiesApiSlice.reducer,
  [salesRepresentativesApiSlice.reducerPath]: salesRepresentativesApiSlice.reducer,
  [providersApiSlice.reducerPath]: providersApiSlice.reducer,
  [profileApiSlice.reducerPath]: profileApiSlice.reducer,
  selectionScope: selectionScope.reducer,
});

export const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware =>
    // eslint-disable-next-line  unicorn/prefer-spread
    getDefaultMiddleware({ serializableCheck: false }).concat(
      selectionsApiSlice.middleware,
      diagnosesApiSlice.middleware,
      diagnosesGroupsApiSlice.middleware,
      generationTaskApiSlice.middleware,
      notificationApiSlice.middleware,
      biomarkersApiSlice.middleware,
      laboratoriesApiSlice.middleware,
      facilitiesApiSlice.middleware,
      salesRepresentativesApiSlice.middleware,
      providersApiSlice.middleware,
      profileApiSlice.middleware,
    ),
  devTools: process.env.NODE_ENV === 'development',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = (): Dispatch<AnyAction> => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
